import React, { useRef } from 'react';
import { Tag } from 'antd';
import { useFormContext } from 'react-hook-form';
import { Button } from 'components/ui';

export default function UploadCredentials({ disabled, isUpdate }) {
  const { setValue, watch } = useFormContext();
  const fileInputRef = useRef(null);

  const credentials = watch('credentials');
  const credentialsUpdated = watch('credentialsUpdated');

  const onClickAddCredentials = () => {
    fileInputRef.current.click();
  };

  const onAddCredentials = e => {
    if (disabled) return;
    const files = Array.from(e.target.files);
    setValue('credentials', files[0]);
    setValue('credentialsUpdated', true);
  };

  return (
    <div>
      <input
        accept="application/json"
        disabled={disabled}
        ref={fileInputRef}
        style={{ display: 'none' }}
        type="file"
        onChange={onAddCredentials}
      />

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Button
          disabled={disabled}
          size="small"
          type="primary"
          onClick={onClickAddCredentials}
        >
          Upload Credential
        </Button>
        {isUpdate && !!credentialsUpdated && (
          <Tag color="#2db7f5" style={{ marginLeft: 5 }}>
            changed
          </Tag>
        )}
      </div>

      {credentials && (
        <div style={{ marginTop: 3 }}>
          <Tag>{credentials.name}</Tag>
        </div>
      )}
    </div>
  );
}
